export var StatusUpdatePrivacy = /*#__PURE__*/ function(StatusUpdatePrivacy) {
    StatusUpdatePrivacy["Shared"] = "SHARED";
    StatusUpdatePrivacy["Private"] = "PRIVATE";
    return StatusUpdatePrivacy;
}({});
export var StatusUpdateState = /*#__PURE__*/ function(StatusUpdateState) {
    StatusUpdateState["Draft"] = "DRAFT";
    StatusUpdateState["Published"] = "PUBLISHED";
    return StatusUpdateState;
}({});
export var TaskStatusType = /*#__PURE__*/ function(TaskStatusType) {
    TaskStatusType["Completed"] = "completed";
    TaskStatusType["Blocked"] = "blocked";
    TaskStatusType["Overdue"] = "became_overdue";
    TaskStatusType["Upcoming"] = "upcoming";
    TaskStatusType["InProgress"] = "in_progress";
    return TaskStatusType;
}({});
export const UserStatusUpdateStatuses = {
    onTrack: {
        type: 'success',
        key: 'onTrack',
        value: 1,
        group: 1,
        color: 'green',
        label: 'On Track',
        labelKey: 'api.status_updates.inferred_progress.on_track'
    },
    aheadOfTime: {
        type: 'inProgress',
        key: 'aheadOfTime',
        value: 2,
        group: 1,
        color: 'teal',
        label: 'Ahead of time',
        labelKey: 'api.status_updates.inferred_progress.ahead_of_time'
    },
    runningLate: {
        type: 'warn',
        key: 'runningLate',
        value: 3,
        group: 1,
        color: 'yellow',
        label: 'Running Late',
        labelKey: 'api.status_updates.inferred_progress.running_late'
    },
    atRisk: {
        type: 'error',
        key: 'atRisk',
        value: 4,
        group: 1,
        color: 'red',
        label: 'At Risk',
        labelKey: 'api.status_updates.inferred_progress.at_risk'
    },
    none: {
        type: 'default',
        key: 'none',
        value: 5,
        group: 1,
        color: 'gray',
        label: 'None',
        labelKey: 'api.status_updates.inferred_progress.none'
    }
};
export const StatusUpdateStatuses = {
    ...UserStatusUpdateStatuses,
    autoPublished: {
        type: 'special',
        key: 'autoPublished',
        value: 6,
        group: 1,
        color: 'purple',
        label: 'Auto published',
        labelKey: 'auto_published'
    }
};
